export default class Helper {
  /**
   * Filter empty values from object
   */
  static filterObjectValues(object = {}) {
    const filteredObject = {};
    
    Object.keys(object).forEach((prop) => {
      if (object[prop]) { filteredObject[prop] = object[prop]; }
    });

    return filteredObject;
  }
}
